/**
 * Returns the input text with any HTML tags destroyed to prevent XSS attacks.
 * This returns safe but un-pretty results so only use it with text that shouldn't contain HTML to begin with.
 * Regular expressions exist that return prettier results but are not completely safe like this method.
 *
 * @param {string} text
 * @return {string}
 */
export default function destroyHtmlTags(text) {
    return text.replace(new RegExp('(\\<|\\>)', 'ig'), '');
}
